'use client'

import { useMapboxContext } from '@component/mapbox/map/context'
import useControl from '../useControl'

export default function ZoomControl () {
  return useControl(<ZoomControlContent></ZoomControlContent>, {position: 'bottom-right'})
}

function ZoomControlContent () {
  const { map } = useMapboxContext()

  function zoomInHandle () {
    map.zoomIn()
  }
  function zoomOutHandle () {
    map.zoomOut()
  }
  return (
    <>
      <button onClick={zoomInHandle} aria-label='zomm in'>
        <i className='icon icon-plus'></i>
      </button>
      <button onClick={zoomOutHandle} aria-label='zoom out'>
        <i className='icon icon-minus'></i>
      </button>
    </>
  )
}
